<template>
    <div class="ah-page business-tax-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <span style="font-size: 14pt; font-weight: bold;">營業稅申報</span>
                    <el-radio-group v-model="activeTab" size="small" @change="onTabClick">
                        <el-radio-button label="QuickDeclare">快速申報</el-radio-button>
                        <el-radio-button label="SummaryTable">查詢總表</el-radio-button>
                    </el-radio-group>
                    <DeclareHelperSteps v-if="isQuickDeclare" :step="currentStep" @onClickStep="n => gotoStep(n)" />
                </div>
            </div>
        </div>
        <div class="fixed-page-content" :class="{ column: isQuickDeclare }">
            <div :class="{ 'helper-wrapper': isQuickDeclare }">
                <router-view @openPayment="onOpenPaymentDetail" @openInvoice="onOpenInvoiceDetail" @openTranInvoice="onOpenTranInvoiceDetail" @openUpdateStatusDialog="onOpenUpdateStatusDialog" />
            </div>
        </div>
        <PaymentDetailDialog :visible="paymentDetailDialog.visible" :sno="paymentDetailDialog.sno" @close="onPaymentDetailDialogClose" />
        <InvoiceDetailDialog :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" @close="onInvoiceDetailDialogClose" />
        <UpdatePeriodDialog :visible="UpdatePeriodDialog.visible" @close="onUpdateStatusDialogClose" />
        <ReimbursementInvoiceDetailDialog :visible="tranInvoiceDetailDialog.visible" :tioo="tranInvoiceDetailDialog.tioo" @close="onTranInvoiceDetailDialogClose" />
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import UpdatePeriodDialog from '@/components/dashboard/Accounting/BusinessTax/UpdatePeriodDialog.vue';
import DeclareHelperSteps from '@/components/dashboard/Accounting/BusinessTax/DeclareHelperSteps.vue';

export default {
    components: {
        UpdatePeriodDialog,
        PaymentDetailDialog: () => import('@/components/dashboard/Payment/PaymentDetailDialog.vue'),
        InvoiceDetailDialog: () => import('@/components/dashboard/Invoice/InvoiceDetailDialog.vue'),
        ReimbursementInvoiceDetailDialog: () => import('@/components/dashboard/Finance/ReimbursementInvoice/ReimbursementInvoiceDetailDialog.vue'),

        DeclareHelperSteps,
    },
    data() {
        return {
            activeTab: 'SummaryTable',

            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },
            tranInvoiceDetailDialog: {
                visible: false,
                tioo: null,
            },
            paymentDetailDialog: {
                visible: false,
                sno: null,
            },
            UpdatePeriodDialog: {
                visible: false,
                snos: [],
            },
        };
    },
    computed: {
        ...mapState({
            period: (state) => state.businessTax.period,
            declarePeriod: (state) => state.businessTax.declarePeriod,
        }),
        isQuickDeclare() {
            this.onRouteChanged();
            return this.$route.name.includes('accounting-business-tax-quick-declare-step');
        },
        currentStep() {
            return Number(this.$route.name.split('-step-')[1]) - 1;
        },
    },
    async created() {
        this.init();

        if (this.isQuickDeclare) this.activeTab = 'QuickDeclare';
        else this.activeTab = 'SummaryTable';
    },
    methods: {
        ...mapMutations({
            updateQuery: 'businessTax/updateQuery',
        }),
        ...mapActions({
            init: 'businessTax/init',
            updateData: 'businessTax/updateData',
        }),

        async onTabClick() {
            if (this.activeTab === 'QuickDeclare' && !this.isQuickDeclare) {
                this.$router.push({ name: 'accounting-business-tax-quick-declare-step-1' });
            } else if (this.activeTab === 'SummaryTable' && this.isQuickDeclare) {
                await this.updateQuery({
                    period: this.period || this.declarePeriod,
                    Foo: null,
                    Bsn: null,
                    Amt: null,
                });
                await this.updateData();
                await this.$router.push({ name: 'accounting-business-tax-summary', query: this.$route.query });
            }
        },
        onRouteChanged() {
            this.activeTab = this.$route.name.includes('accounting-business-tax-quick-declare-step') ? 'QuickDeclare' : 'SummaryTable';

            if (this.$route.name === 'accounting-business-tax') {
                this.activeTab = 'QuickDeclare';
                this.$router.push({ name: 'accounting-business-tax-quick-declare-step-1' });
            }
        },

        gotoStep(n) {
            if (this.currentStep + 1 === n) return; // 避免重複點目前步驟
            this.$router.push({ name: `accounting-business-tax-quick-declare-step-${n}`, query: this.$route.query });
        },

        onOpenPaymentDetail(sno) {
            this.paymentDetailDialog.sno = sno;
            this.paymentDetailDialog.visible = true;
        },
        onOpenInvoiceDetail(sno) {
            this.invoiceDetailDialog.sno = sno;
            this.invoiceDetailDialog.visible = true;
        },
        onOpenTranInvoiceDetail(tioo) {
            this.tranInvoiceDetailDialog.tioo = tioo;
            this.tranInvoiceDetailDialog.visible = true;
        },
        onOpenUpdateStatusDialog(datas) {
            this.UpdatePeriodDialog.visible = true;
            this.UpdatePeriodDialog.snos = datas;
        },

        // Detail dialog Close 事件
        onInvoiceDetailDialogClose(refresh) {
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
            if (refresh) this.updateData();
        },
        onTranInvoiceDetailDialogClose(refresh) {
            this.tranInvoiceDetailDialog.visible = false;
            this.tranInvoiceDetailDialog.tioo = null;
            if (refresh) this.updateData();
        },
        onPaymentDetailDialogClose(refresh) {
            this.paymentDetailDialog.visible = false;
            this.paymentDetailDialog.sno = null;
            if (refresh) this.updateData();
        },
        onUpdateStatusDialogClose() {
            this.UpdatePeriodDialog.visible = false;
            this.UpdatePeriodDialog.snos = [];
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.business-tax-page {
    &.ah-page {
        padding: 0;
    }
    &.ah-page .page-header .title-row {
        display: flex;
        align-items: center;
        gap: 20px;
        height: 60px;

        .el-radio-group {
            .el-radio-button__inner {
                border: 0;
                background-color: #7067d5;
                color: #fff;
                font-weight: bold;
            }
            .el-radio-button.is-active {
                .el-radio-button__inner {
                    background-color: #fff;
                    color: #463cb2;
                }
            }
        }
    }
    .fixed-page-content {
        background-color: #fff;
        margin-top: -25px;
        // height: calc(100vh - 40px - 65px - 80px);
        // overflow: hidden;
        display: flex;
        &.column {
            flex-direction: column;
            background-color: initial;
        }
    }
    &.ah-page .page-header .title-row .actions {
        padding: 0;
        vertical-align: bottom;
    }
    .function-tab {
        width: 200px;
        .el-tabs__item {
            color: #fff;
            font-size: 11pt;
            font-weight: bold;

            &.is-active {
                color: #fff;
            }
        }
        .el-tabs__active-bar {
            background-color: #fac300;
            height: 4px;
        }
        .el-tabs__nav-wrap {
            margin-bottom: 0px;
            &::after {
                background-color: $main-color;
            }
        }
        .el-tabs--bottom .el-tabs__header.is-bottom {
            margin-bottom: 1px;
        }
    }

    .helper-wrapper {
        height: calc(100vh - 300px);
    }
}
</style>
